import React, { useState, useCallback } from 'react'
import dayjs from 'dayjs'
import { Input, Button, Form } from 'antd'
import { useModalWrap } from '@/components'
import gioTrackEvent from '@/utils/gio'
import eventMap from '@/utils/gio/eventMap'
import IconSvg from '@/components/IconSvg'
import { useTranslation } from '@/libs/next-lang'
import { getCoupon } from './services'
import styles from './index.module.less'

const useBenefitCollectionModal = () => {
  const [success, setSuccess] = useState(false)
  const [detail, setDetail] = useState<any>({})
  const { t } = useTranslation(['header'])

  // 优惠券兑换
  const onCollection = useCallback(async form => {
    gioTrackEvent(eventMap.coupon_submit)
    try {
      const values = await form.validateFields()
      const { couponCode } = values
      const { data } = await getCoupon({ couponCode })
      if (data?.code === 0) {
        // message.success(data.message || '优惠券兑换成功')
        setDetail(data.result)
        setSuccess(true)
        // hideModal()
      }
    } catch (error) {
      // if (!error?.errorFields) {
      //   message.error(error?.message)
      // }
      console.error('优惠券兑换失败: ', error)
    }
  }, [])

  const { showModal, hideModal, form, render } = useModalWrap({
    modalProps: {
      title: null,
      width: 525,
      bodyStyle: { padding: 0 },
      footer: null,
      afterClose: () => {
        setSuccess(false)
        form.resetFields()
      },
      // closable:false,
      onCancel: () => {
        hideModal()
      },
    },
    children: ({ form }) => (
      <div className={styles['content-wrapper']}>
        <div className="title">
          <div>{t('header:t14')}</div>
        </div>
        {!success ? (
          <>
            <Form.Item
              name="couponCode"
              rules={[{ required: true, message: t('header:t19'), whitespace: true }]}
            >
              <Input placeholder={t('header:t20')} />
            </Form.Item>
            <div style={{ marginTop: 60 }}>
              <Button
                className="collect-btn"
                block
                type="primary"
                onClick={() => onCollection(form)}
              >
                {t('header:t21')}
              </Button>
            </div>
          </>
        ) : (
          <div className="success-result" style={{ textAlign: 'center' }}>
            <div>
              <IconSvg type="icon-chenggong2" />
              <span className="ml-5" style={{ fontSize: 18 }}>
                {t('header:t22')}
              </span>
            </div>
            <div style={{ fontSize: 16 }}>
              <span style={{ color: '#FFD27F' }}>{detail.couponName}</span>
              <span className="ml-10" style={{ marginTop: 24, display: 'inline-block' }}>
                {t('header:t23')}：{dayjs(detail.validEnd).format('YYYY-MM-DD')}
              </span>
            </div>
          </div>
        )}
      </div>
    ),
  })

  return {
    showModal,
    hideModal,
    render,
  }
}

export default useBenefitCollectionModal
